module.exports = __webpack_public_path__ + "static/media/logo.5d52459f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 848
// module chunks = 0